// Páginas com layout de Impressão

const print = [
  {
    path: '/print',
    name: 'Impressão',
    component: () => import('@/view/Layouts/PrintContainer/PrintContainer.vue'),
    meta: {
      auth: true,
    },
    children: [
      {
        path: 'boleto/:id',
        name: 'Visualização de Boleto',
        component: () => import('@/view/pages/shared/printables/invoices/Boleto.vue'),
      },
      {
        path: '/carne/:id',
        name: 'Visualização de Carne',
        component: () => import('@/view/pages/shared/printables/invoices/Carne.vue'),
      },
      {
        path: '/account/deposit/:id',
        name: 'Contas - Depósitos -  Imprimir Boleto de Depósito',
        component: () => import('@/view/pages/shared/printables/invoices/Deposit.vue'),
      },
      {
        path: '/statement/print',
        name: 'Extrato - Imprimir Extrato Completo',
        component: () => import('@/view/pages/shared/printables/statement/Statement.vue'),
      },
      {
        path: '/statement/print-summary',
        name: 'Extrato - Imprimir Extrato Resumido',
        component: () => import('@/view/pages/shared/printables/statement/SummaryStatement.vue'),
      },
      {
        path: '/debenture/:id/print',
        name: 'Debenture - Extrato',
        component: () => import('@/view/pages/shared/printables/statement/DebentureStatement.vue'),
      },
      {
        path: '/receipt/:id',
        name: 'Imprimir Recibo',
        component: () => import('@/view/pages/shared/printables/receipts/Receipt.vue'),
      },
      {
        path: '/receipts/',
        name: 'Imprimir Lote Recibos',
        component: () => import('@/view/pages/shared/printables/receipts/BulkReceipt.vue'),
      },
      {
        path: '/reports/print/synthetic',
        name: 'Relatórios - Visualizar Relatorio Sintetico',
        component: () => import('@/view/pages/shared/printables/reports/RelatorioSintetico.vue'),
      },
      {
        path: '/reports/print/analytic',
        name: 'Relatórios - Visualizar Relatorio Analitico',
        component: () => import('@/view/pages/shared/printables/reports/RelatorioAnalitico.vue'),
      },
      {
        path: '/admin/reports/dailyop',
        name: 'Admin - Relatórios - Visualizar Diario de Operacoes Digitais',
        component: () =>
          import('@/view/pages/shared/printables/statement/OperationsDailyStatement.vue'),
        meta: {
          auth: true,
          admin: true,
        },
      },
      {
        path: '/reports/print/irpf',
        name: 'Imprimir Declaração de Imposto de Renda',
        component: () => import('@/view/pages/shared/printables/reports/IRPF.vue'),
      },
      {
        path: 'admin/reports/relatorio-bloqueios',
        name: 'Imprimir Relatório de Bloqueio de Valores',
        component: () => import('@/view/pages/shared/printables/reports/BlockReport.vue'),
      },
      {
        path: 'debts/single/:id/',
        name: 'Créditos - Detalhes de Título - Impressão',
        component: () => import('@/view/pages/shared/printables/debts/SingleDetails.vue'),
      },
    ],
  },
]

export default print
